import React from 'react';
import { motion } from 'framer-motion';
import profileImage from '../assets/images/PR.jpg';
import { aboutData } from '../data/about';
import { useLanguage } from '../i18n';
import { localize } from '../i18n/localize';

const About = () => {
  const { t, language } = useLanguage();
  return (
    <section id="about" className="about">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
        >
          <h2>{t('about.title')}</h2>
          <div className="section-divider"></div>
        </motion.div>

        <div className="about-content">
          {/* Seção Principal com Foto e Introdução */}
          <motion.div
            className="about-main"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
          >
            <div className="about-image-section">
              <div className="profile-image-container">
                <img 
                  src={profileImage} 
                  alt="Pedro - Desenvolvedor Backend" 
                  className="profile-image"
                />
              </div>
              
              {/* Nome abaixo da foto */}
              <motion.div
                className="profile-name"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: 0.05 }}
              >
                <h3>Pedro Riccio</h3>
              </motion.div>
              
              {/* Estatísticas pequenas abaixo da foto */}
              <motion.div
                className="about-mini-stats"
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: 0.1 }}
              >
                {aboutData.stats.map((stat) => (
                  <div className="mini-stat" key={stat.id}>
                    <span className="mini-stat-number">{stat.number}</span>
                    <span className="mini-stat-label">{localize(stat, 'label', language)}</span>
                  </div>
                ))}
              </motion.div>
            </div>
            
            <div className="about-intro">
              <h3>{localize(aboutData, 'subtitle', language)}</h3>
              {localize(aboutData, 'description', language)
                .split('\n\n')
                .map((para, idx) => (
                  <p key={idx} className="about-description">{para}</p>
                ))}
              {aboutData.interests && aboutData.interests.length > 0 && (
                <div className="about-interests-wrap" style={{ marginTop: '1.25rem' }}>
                  <span style={{ 
                    display: 'block', 
                    fontSize: '0.75rem', 
                    fontFamily: 'var(--font-mono)', 
                    color: 'var(--neon-cyan)', 
                    textTransform: 'uppercase', 
                    letterSpacing: '0.08em',
                    marginBottom: '0.6rem'
                  }}>
                    {language === 'en' ? '⚡ Focus & Core Domains' : language === 'es' ? '⚡ Enfoque y Dominios Principales' : '⚡ Áreas de Foco & Domínios'}
                  </span>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                    {aboutData.interests.map((interest, idx) => (
                      <span 
                        key={idx} 
                        style={{
                          fontSize: '0.75rem',
                          fontFamily: 'var(--font-mono)',
                          padding: '0.25rem 0.6rem',
                          borderRadius: '4px',
                          border: '1px solid rgba(0, 240, 255, 0.25)',
                          background: 'rgba(0, 240, 255, 0.08)',
                          color: 'var(--text-primary)'
                        }}
                      >
                        {interest}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;